var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3334 17.3335H16.6667C15.5622 17.3335 14.6667 18.2289 14.6667 19.3335V31.3335C14.6667 32.4381 15.5622 33.3335 16.6667 33.3335H31.3334C32.438 33.3335 33.3334 32.4381 33.3334 31.3335V19.3335C33.3334 18.2289 32.438 17.3335 31.3334 17.3335Z",
    stroke: "#1B2559",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 17.3332V15.3332C18.6667 14.9332 18.9334 14.6665 19.3334 14.6665H28.6667C29.0667 14.6665 29.3334 14.9332 29.3334 15.3332V17.3332",
    stroke: "#1B2559",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.6665H28",
    stroke: "#1B2559",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.6665H25.3333",
    stroke: "#1B2559",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollections);
export default __webpack_public_path__ + "static/media/Collections.71598dac8765abc4715707996189e47d.svg";
export { ForwardRef as ReactComponent };